// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import VideoJsx from "./video.jsx";

var make = VideoJsx;

var Video = {
  make: make
};

function V3Video$Wrapper(props) {
  return React.createElement("div", {
              className: "pilot-video",
              onClick: (function (evt) {
                  evt.stopPropagation();
                })
            }, React.createElement(make, {
                  options: props.options
                }));
}

var Wrapper = {
  make: V3Video$Wrapper
};

var make$1 = V3Video$Wrapper;

var $$default = V3Video$Wrapper;

export {
  Video ,
  Wrapper ,
  make$1 as make,
  $$default as default,
}
/* make Not a pure module */
